import script from "./TableSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSlide.vue?vue&type=script&setup=true&lang=js"

import "./TableSlide.vue?vue&type=style&index=0&id=17065dd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17065dd0"]])

export default __exports__